import React, { useState } from "react";
import { Modal, Form, Input, Select, message, Switch } from "antd";
import Instance from "../../AxiosConfig";

const { Option } = Select;

const AddBankModal = ({ open, onClose, company, refresh }) => {
  const [form] = Form.useForm();
const [regionType, setRegionType] = useState("India");
  const handleSubmit = async (values) => {
    try {
        const { regionType, ...payload } = values;
      const response = await Instance.post(
        `/companyDetails/${company._id}/banks`,
        payload,
      );
      console.log("Bank details:", response);
      message.success("Bank added");
      form.resetFields();
      onClose();
      refresh();
    } catch (err) {
      message.error(err?.response?.data?.message || "Error");
    }
  };

  return (
    <Modal
      title={`Add Bank - ${company?.companyName || ""}`}
      open={open}
      onCancel={onClose}
      onOk={() => form.submit()}
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item name="regionType" label="Type" initialValue="India">
         <Select onChange={(val) => setRegionType(val)}>
            <Option value="India">India</Option>
            <Option value="International">International</Option>
          </Select>
        </Form.Item>
        <Form.Item
          name="country"
          label="Country"
          rules={[{ required: true, message: "Please enter country" }]}
        >
          <Input placeholder="Enter country (e.g., India, USA)" />
        </Form.Item>

        <Form.Item
          name="bankName"
          label="Bank Name"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="accountNumber"
          label="Account Number"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        {/* INDIA */}
        {regionType === "India" && (
          <>
            <Form.Item name="beneficiaryName" label="Beneficiary Name">
              <Input />
            </Form.Item>

            <Form.Item name="ifscCode" label="IFSC Code">
              <Input />
            </Form.Item>
          </>
        )}

        {/* INTERNATIONAL */}
        {regionType !== "India" && (
          <>
            <Form.Item name="accountHolderName" label="Account Holder Name">
              <Input />
            </Form.Item>

            <Form.Item name="paymentMethod" label="Payment Method">
              <Input />
            </Form.Item>

            <Form.Item name="routingCode" label="Routing Code">
              <Input />
            </Form.Item>

            <Form.Item name="routingType" label="Routing Type">
              <Input />
            </Form.Item>

            <Form.Item name="bankAddress" label="Bank Address">
              <Input />
            </Form.Item>
            {/* <Form.Item name="currency" label="Currency">
              <Input />
            </Form.Item> */}
          </>
        )}

        <Form.Item name="isDefault" label="Set Default" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddBankModal;
